import React, { useMemo } from "react";

import ErrorIcon from "@mui/icons-material/ErrorOutline";

import { usePortfolioBuilderContext } from "../../PortfolioBuilder/reducer/Context";
import {
  getTotalWeight,
  hasLooseSecuritiesOrSleeves,
} from "../../PortfolioBuilder/reducer/reducer";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TableRow.module.css";

const BottomRow: React.FC = () => {
  const { state } = usePortfolioBuilderContext();

  const totalWeight = useMemo(
    () => getTotalWeight(state.modelTable).toNumber(),
    [state.modelTable]
  );

  const hasLooseSecuritiesOrSleevesAndAssetClasses = useMemo(
    () =>
      hasLooseSecuritiesOrSleeves(state.modelTable) &&
      state.modelTable.length >= 2,
    [state.modelTable]
  );

  return (
    <div className={styles.bottomRow}>
      <Text variant="body" color={"text"}>
        Total Weight
      </Text>

      <div className={styles.flexRow}>
        {(totalWeight !== 100 ||
          hasLooseSecuritiesOrSleevesAndAssetClasses) && (
          <Tooltip
            tooltipText={
              totalWeight !== 100
                ? "Total weight must equal 100.00%"
                : "All securities and sleeves must be assigned to an asset class or no asset class. Cannot have a mix of both."
            }
            placement={"top"}
          >
            <ErrorIcon className={styles.errorIcon} color={"error"} />
          </Tooltip>
        )}

        <Text variant="body" color={"text"}>{`${totalWeight} %`}</Text>
      </div>
    </div>
  );
};

export default BottomRow;
